import React, { Component }  from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'
import moment from 'moment'
import { getTimezoneDate } from 'utils/date'
import {getMonth} from 'utils/date'

import CommonTable from 'components/Table'
import { Column } from 'react-virtualized'
import Badge from 'components/Badge'
import ProjectStatus from './Status'

import { properties, managers, projects } from 'selectors/entities'
import { projectsEx } from 'selectors/projects'
import { projectsTable } from 'selectors/projects'

let select = (state, props) => ({
	projects: props.data!=undefined ? props.data : projectsTable(state)
  , managers: managers(state)
  , properties: properties(state)
})

export class ProjectsTable extends Component{
	render(){
		let { props } = this
		let width = props.width || (window.innerWidth-60)
		let widthCategory = width>900 ? 3 : width>600 ? 2 : 1
		return(
			<CommonTable entity="project" showAll={props.showAll} data={props.projects}>
				{widthCategory>1 && <Column
					width={60}
					label={<span>status</span>}
					dataKey='projectStatus'
					flexShrink={0}
					cellRenderer={
						({ rowData }) => <ProjectStatus projectStatus={rowData.status.status} />
					}
				/>
				}
				<Column
				  width={350}
				  label='Property'
				  dataKey='propertyAlias'
				  cellRenderer={
					  ({ rowData }) => (
						<div>
							{rowData.propertyAlias}
						</div>
					  )
				  }
				/>
				<Column
					width={450}
					label='Title'
					dataKey='title'
				/>
				{widthCategory>1 && <Column
				  width={400}
				  label='Manager'
				  dataKey='managerName'
				  cellRenderer={
					  ({ rowData }) => (
						<div>
							{rowData.managerName}
						</div>
					  )
				  }
				/>}

				{widthCategory>2 && <Column
					width={200}
					dataKey='dateStarted'
					headerRenderer={()=><div style={{textAlign:"right", width:"100%", height:"19px", paddingRight:"30px"}}>Started</div>}
					style={{textAlign:"right"}}
					cellRenderer={
						({ rowData }) => (
							(rowData.dateStarted)?
							<div style={{textAlign:"right", marginRight:"30px"}}>
								{`${getTimezoneDate(rowData.dateStarted).getDate()} ${getMonth(getTimezoneDate(rowData.dateStarted).getMonth())} ${getTimezoneDate(rowData.dateStarted).getFullYear()}`}
							</div>:''
						)
					}
				/>}

				{widthCategory>2 && <Column
					width={200}
					dataKey='dateClosed'
					headerRenderer={()=><div style={{textAlign:"right", width:"100%", height:"19px", paddingRight:"30px"}}>Closed</div>}
					style={{textAlign:"right"}}
					cellRenderer={
						({ rowData }) => (
							(rowData.dateClosed)?
							<div style={{textAlign:"right", marginRight:"30px"}}>
								{`${getTimezoneDate(rowData.dateClosed).getDate()} ${getMonth(getTimezoneDate(rowData.dateClosed).getMonth())} ${getTimezoneDate(rowData.dateClosed).getFullYear()}`}
							</div>:''
						)
					}
				/>}

				{widthCategory==3 &&
  				  <Column
  					width={50}
  					label={
						<img src={"/manager/static/img/res/ch_gray.png"}
							style={{height: "22px !important", width: "22px"}}
						/>
					}
  					dataKey='tasks'
  					disableSort
  					cellRenderer={({ rowData }) =>
  						<Badge
  							style={{position:"relative", top:"8px", left:"-8px"}}
  							badgeContent={rowData.tasks.length}
  							primary={false}
  							secondary={!!rowData.tasks.length}
  					    />
  					}
  				  />
  				}

				{widthCategory==3 && <Column
					width={50}
					label={<i style={{fontSize:"22px"}} className="material-icons">comment</i>}
					dataKey='comments'
					disableSort
					cellRenderer={({ rowData }) =>
						<Badge
							style={{position:"relative", top:"8px", left:"-8px"}}
							badgeContent={rowData.comments.length}
							primary={false}
							secondary={!!rowData.comments.length}
					    />
					}
				/>
				}
				{widthCategory==3 && <Column
					width={50}
					label={<i style={{fontSize:"22px"}} className="material-icons">attach_file</i>}
					dataKey='attachments'
					disableSort
					cellRenderer={({ rowData }) =>
						<Badge
							style={{position:"relative", top:"8px", left:"-8px"}}
							badgeContent={rowData.attachments ? rowData.attachments.length : "0"}
							primary={false}
							secondary={rowData.attachments ? !!rowData.attachments.length : false}
					    />
					}
				/>
				}
			</CommonTable>
		)
	}
}
export default connect(select)(ProjectsTable)



// WEBPACK FOOTER //
// ./src/routes/manager/projects/Table.js